export default "__VITE_ASSET__c50ad2e4__"